import script from "./TheTestsAb.vue?vue&type=script&setup=true&lang=js"
export * from "./TheTestsAb.vue?vue&type=script&setup=true&lang=js"

import "./TheTestsAb.vue?vue&type=style&index=0&id=495a262a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-495a262a"]])

export default __exports__